export default __webpack_public_path__ + "static/media/dashboard-2.e598c51c.png";